import HeadingComponent from "components/headingComponent";
import {
  query,
  collection,
  or,
  and,
  where,
  getDocs,
  Timestamp,
  addDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import CommonHeadings from "helper/constant/headings";
import PayementMethod from "helper/constant/paymentMethod";
import Dateformat from "helper/constant/timeFormat";
import ErrorMessages from "helper/errorMessages";
import TableName from "helper/tableName/tableName";
import ToastMessages from "helper/toastMessages";
import moment from "moment";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useLayoutEffect, useState } from "react";
import Moment from "react-moment";
import AsyncSelect from "react-select/async";
import { toast, ToastContainer } from "react-toastify";
import "./index.css";
import ListHeadingComponent from "components/headingComponent/listHeading";

function FeesData() {
  const [isSubmitted, setIsSubmitted] = useState(false); // when we submit the form, it will check the error
  const [loading, setLoading] = useState(false);

  const [studentsFeeData, setStudentsFeeData] = useState([]);
  const [totalPaidAmount, setTotalPaidAmount] = useState(null);

  const dropdownValues = [
    PayementMethod.card,
    PayementMethod.cash,
    PayementMethod.upi,
  ]; // in this file , we just define the marital keys\

  // MARK: use layout effect function
  useLayoutEffect(() => {
    document.title = CommonHeadings.feeLayoutHeading;
  }, []);

  const [feesData, setFeesData] = useState({
    student: null,
    batch_fee: "",
    batch_fee_num: null,
    month: null,
    date: new Date(),
    date_timestamp: null,
    amount: "",
    amount_num: null,
    payment_method: null,
  });

  const [errors, setErrors] = useState({
    student: null,
    month: "",
    date: "",
    amount: "",
    payment_method: "",
  });

  const validateForm = (data) => {
    const errors = {};

    if (!data.student) {
      errors.student = ErrorMessages.studentSelect;
    }
    if (!data.month) {
      errors.month = ErrorMessages.monthDate;
    }
    if (!data.amount) {
      errors.amount = ErrorMessages.amount;
    } else if (!/^[0-9\b]+$/.test(data.amount)) {
      errors.amount = ErrorMessages.amountNumber;
    }
    if (!data.date) {
      errors.date = ErrorMessages.feeDate;
    }
    if (!data.payment_method) {
      errors.payment_method = ErrorMessages.paymentMethod;
    }

    return errors;
  };

  const selectPaymentMethod = (e) => {
    const { name, value } = e.target;

    setFeesData({
      ...feesData,
      [name]: value,
    });
  };

  const selectStudent = (e) => {
    if (e === null) {
      setFeesData((prevState) => ({
        ...prevState,
        student: null,
        batch_fee: "",
      }));
      return;
    }

    setFeesData((prevState) => ({
      ...prevState,
      student: e,
      batch_fee: e.batch_fee,
    }));

    if (feesData.month) {
      fetchPreviousFees(e, feesData.month);
      calculateAmount(e, feesData.month);
    }

  };

  //   when we enter any value that's set in the setDemoStudents() and chenge the input afer submitting like blank all the inputs
  const inputChange = (e) => {
    var { name, value } = e.target;

    setFeesData({
      ...feesData,
      [name]: value,
    });

    if (name === "month" && feesData.student) {
      fetchPreviousFees(feesData.student, value);
      calculateAmount(feesData.student, value);
    }
  };

  // MARK: reset values function
  function ResetValues() {
    setFeesData({
      student: null,
      batch_fee: "",
      batch_fee_num: null,
      month: null,
      date: new Date(),
      date_timestamp: null,
      amount: "",
      amount_num: null,
      payment_method: null,
    });
  }

  // this function is working when we submit the form by clicking on save button
  const tapOnSave = () => {
    const newErrors = validateForm(feesData);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      // setLoading(true);
      writefeeApi();
      ResetValues();
      setStudentsFeeData(null);
    }
  };

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();
    const object = {
      created_at: createdAt,
    };

    object.batch_fee_num = Number(feesData.batch_fee);
    object.amount = Number(feesData.amount);
    object.student_id = feesData.student.id;
    object.month = moment(feesData.month).format(Dateformat.MMYYYY);
    object.fees_date = moment(feesData.date).format(Dateformat.YYYYMMDD);
    object.payment_method = feesData.payment_method.toLowerCase();
    object.month_timestamp = Timestamp.fromDate(feesData.month).toMillis();

    return object;
  }

  function pending_fees_payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();
    const object = {
      created_at: createdAt,
      updated_at: createdAt,
    };

    if (totalPaidAmount) {
      object.pending_amount = Number(feesData.batch_fee) - (Number(feesData.amount) + totalPaidAmount);
    } else {
      object.pending_amount = Number(feesData.batch_fee) - Number(feesData.amount);
    }
    object.student_id = feesData.student.id;
    object.month = moment(feesData.month).format(Dateformat.MMYYYY);
    object.month_timestamp = Timestamp.fromDate(feesData.month).toMillis();

    return object;
  }

  // MARK: write API
  async function writefeeApi() {

    try {
      updatePendingPayment();
    } catch (error) {
      setLoading(false); // hide
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }


  //MARK: update pending payment function
  async function updatePendingPayment() {
    const writePayload = payload();

    const q = query(
      collection(dbFirestore, TableName.pendingFees),
      where("student_id", "==", feesData.student.id),
      where("month", "==", moment(feesData.month).format(Dateformat.MMYYYY)),
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.docs.length > 0) {

      const queryModel = querySnapshot.docs[0];

      const pendingPaymentModel = queryModel.data();
      const pendingPaymentId = queryModel.id;

      if (Number(feesData.amount) > pendingPaymentModel.pending_amount) {
        toast.error(`You can only pay Rs.${pendingPaymentModel.pending_amount}`)
      } else {

        const pending_amount = pendingPaymentModel.pending_amount - Number(feesData.amount)
        await updateDoc(doc(dbFirestore, TableName.pendingFees, pendingPaymentId), {
          pending_amount: pending_amount,
        });

        const writePayload = payload();

        await addDoc(collection(dbFirestore, TableName.fee), {
          ...writePayload,
        });

        toast.success(ToastMessages.feeDetailAdd);
        setLoading(false);
      }

    } else if (writePayload.amount > writePayload.batch_fee_num) {

      toast.error(`You can only pay Rs.${writePayload.batch_fee_num}`)
    } else {
      const pendingFees = pending_fees_payload();
      await addDoc(collection(dbFirestore, TableName.pendingFees), {
        ...pendingFees,
      });

      const writePayload = payload();

      await addDoc(collection(dbFirestore, TableName.fee), {
        ...writePayload,
      });

      toast.success(ToastMessages.feeDetailAdd);
      setLoading(false);
    }
  }

  // MARK: students list fetch from the firebase
  const studentsList = async (searchText) => {
    const searchName = searchText.toLowerCase()
    let q = query(
      collection(dbFirestore, TableName.students), and(
        where('status', '==', 'active'),   
      or(
        // query as-is:
        and(
          where("name", ">=", searchName),
          where("name", "<=", searchName + "\uf8ff")
        ),
        and(
          where(
            "name",
            ">=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1)
          ),
          where(
            "name",
            "<=",
            searchName.charAt(0).toUpperCase() + searchName.slice(1) + "\uf8ff"
          )
        )
      )
    ));
    const querySnapshot = await getDocs(q);
    const s = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.id,
    }));

    return s;
  };

  // MARK: students name which show in the dropdown
  function studentsName(e) {
    return e["name"] + " - " + e["admission_no"];
  }

  // MARK: students fee columns data
  const studentsfeeInfoColumns = [
    {
      field: "month",
      header: "Month",
    },
    {
      field: "payment_method",
      header: "Payment Method",
      className: "table__column__capital"
    },
    {
      field: "amount",
      header: "Amount",
    },
    {
      field: "date",
      header: "Payment Date",
      CardBody: (data) => (
        <Moment format={Dateformat.DDMMYYYY}>{data.date}</Moment>
      ),
    },
  ];

  // MARK: fetch fee API
  async function fetchPreviousFees(selectedStudent, selectedMonth) {
    const q = query(
      collection(dbFirestore, TableName.fee),
      where("student_id", "==", selectedStudent.id),
      where("month", "==", moment(selectedMonth).format(Dateformat.MMYYYY)));


    const querySnapshot = await getDocs(q);
    const array = querySnapshot.docs.map((docs) => ({
      ...docs.data(),
      id: docs.id,
    }));
    setStudentsFeeData(array);
  }

  //MARK: count the total maount
  async function calculateAmount(selectedStudent, selectedMonth) {
    const q = query(
      collection(dbFirestore, TableName.fee),
      where("student_id", "==", selectedStudent.id),
      where("month", "==", moment(selectedMonth).format(Dateformat.MMYYYY)));

    const querySnapshot = await getDocs(q);

    const amountSum = querySnapshot.docs.reduce(
      (total, currentValue) => (total = total + currentValue.data().amount),
      0
    );
    setTotalPaidAmount(amountSum);
  }

  return (
    <>
      <div className="fees-form-container">
        <div className="col-12">
          <div className="card modules__card">
            <HeadingComponent
              classname="mb-4"
              headingName={CommonHeadings.feeheading}
            />
            {/* p-fluid is the primereact class */}
            <div className="p-fluid">
              <div className="row modules__row">
                <div className="col-12 col-md-6">
                  <label htmlFor="student_id">Select Student</label>

                  <AsyncSelect
                    className="table__column__capital"
                    maxMenuHeight={170}
                    isClearable
                    cacheOptions
                    loadOptions={studentsList}
                    value={feesData.student}
                    defaultOptions
                    getOptionLabel={(e) => studentsName(e)}
                    getOptionValue={(e) => e}
                    onChange={selectStudent}
                  />
                  {isSubmitted && (
                    <small id="student" className="p-error">
                      {errors.student}{" "}
                    </small>
                  )}
                </div>

                <div className="col-12 col-md-6">
                  <label htmlFor="batch_fee">Batch Fee</label>
                  <InputText
                    name="batch_fee"
                    value={feesData.batch_fee}
                    onChange={inputChange}
                    id="batch_fee"
                    type="text"
                    placeholder="Enter batch fee"
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label htmlFor="month"> Select Month</label>
                  <Calendar
                    name="month"
                    value={feesData.month}
                    onChange={inputChange}
                    showIcon
                    showButtonBar
                    placeholder={Dateformat.Mmyy}
                    dateFormat={Dateformat.Mmyy}
                    view="month"
                  />
                  {isSubmitted && (
                    <small id="month" className="p-error">
                      {errors.month}{" "}
                    </small>
                  )}
                </div>

                <div className="col-12 col-md-6">
                  <label htmlFor="date"> Select Date</label>
                  <Calendar
                    name="date"
                    value={feesData.date}
                    onChange={inputChange}
                    showIcon
                    showButtonBar
                    placeholder="dd-MM-yy"
                    dateFormat="dd-MM-yy"
                  />
                  {isSubmitted && (
                    <small id="date" className="p-error">
                      {errors.date}{" "}
                    </small>
                  )}
                </div>

                <div className="col-12 col-md-6">
                  <label htmlFor="amount">Amount</label>
                  <InputText
                    name="amount"
                    value={feesData.amount}
                    onChange={inputChange}
                    id="amount"
                    type="text"
                    placeholder="Enter amount"
                  />
                  {isSubmitted && (
                    <small id="amount" className="p-error">
                      {errors.amount}{" "}
                    </small>
                  )}
                </div>

                <div className="col-12 col-md-6">
                  <label htmlFor="payment_method"> Select Payment Method</label>
                  <Dropdown
                    name="payment_method"
                    value={feesData.payment_method}
                    onChange={selectPaymentMethod}
                    options={dropdownValues}
                    optionLabel="name"
                    placeholder="Select payment method"
                  />
                  {isSubmitted && (
                    <small id="payment_method" className="p-error">
                      {errors.payment_method}{" "}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <div className="flex mt-5">
              <Button
                label="Save"
                type="button"
                loading={loading}
                onClick={tapOnSave}
                className="modules__save_button me-3"
              />
            </div>
            <ToastContainer />
          </div>
        </div>
      </div>

      {feesData.student && (
        <div className="fee_table_main_div">
          <div className="col-12">
            <div className="card modules__card">
              <div className="modules__lists_main-content">
                <ListHeadingComponent
                  classname="flex-grow-1"
                  headingName="Transaction History"
                />
                <h5>Total Amount: Rs. {totalPaidAmount?.toLocaleString()}</h5>
              </div>
              <DataTable
                className="mt-5 mb-3"
                value={studentsFeeData}
                emptyMessage="No data found."
              >
                {studentsfeeInfoColumns.map((col) => (
                  <Column
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    bodyClassName={col.className}
                    body={col.CardBody}
                  />
                ))}
              </DataTable>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default FeesData;
